import { render } from "./MemberDetails.vue?vue&type=template&id=5b02f6c2&scoped=true"
import script from "./MemberDetails.vue?vue&type=script&lang=js"
export * from "./MemberDetails.vue?vue&type=script&lang=js"

import "./MemberDetails.vue?vue&type=style&index=0&id=5b02f6c2&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b02f6c2"]])

export default __exports__